import { render, staticRenderFns } from "./HeatmapPanel.vue?vue&type=template&id=70f4e473&scoped=true"
import script from "./HeatmapPanel.vue?vue&type=script&lang=js"
export * from "./HeatmapPanel.vue?vue&type=script&lang=js"
import style0 from "./HeatmapPanel.vue?vue&type=style&index=0&id=70f4e473&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f4e473",
  null
  
)

export default component.exports